import { render } from "./SidebarSettingsMenu.vue?vue&type=template&id=1b71af90&scoped=true"
import script from "./SidebarSettingsMenu.vue?vue&type=script&lang=js"
export * from "./SidebarSettingsMenu.vue?vue&type=script&lang=js"

import "./SidebarSettingsMenu.vue?vue&type=style&index=0&id=1b71af90&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b71af90"]])

export default __exports__